import React from "react";

import SubscriptionFormModal from "./SubscriptionFormModal";

export default function AddSubscriptionModal(
  props,
) {
  return (
    <SubscriptionFormModal
      {...props}
      mode="create"
    />
  );
}